import { StyleSheet } from "../../../components/Common/react-native-components";

export const getStyles = isMobile =>
    StyleSheet.create({
        cardContentWrapper: {
            paddingHorizontal: isMobile ? 16 : 90
        },
        section: {
            paddingVertical: 20,
            paddingHorizontal: 20,
            borderBottomWidth: 1,
            borderBottomColor: '#f0f0f0'
        },
        headerContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingVertical: 16,
            paddingHorizontal: 30,
            borderBottomWidth: 1,
            borderBottomColor: '#f0f0f0'
        },
        ratingBadge: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4,
            paddingRight: 12
        },
        divider: {
            width: 1,
            height: 50,
            backgroundColor: '#e0e0e0',
            marginRight: 12
        },
        emojiSubIcon: {
            width: 25,
            height: 25
        },
        headerContent: {
            flex: 1
        },
        buttonContainer: {
            paddingVertical: 20,
            paddingHorizontal: 20,
            borderBottomWidth: 1,
            borderBottomColor: '#f0f0f0',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'row',
            gap: '5px'
        },
        profileSection: {
            paddingVertical: 40,
            paddingHorizontal: 20,
            borderBottomWidth: 1,
            borderBottomColor: '#f0f0f0'
        },
        infoRow: {
            marginTop: 20,
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: 40,
            flexWrap: 'wrap'
        },
        column: {
            flex: 1
        },
        leftColumn: {
            flex: 1,
            minWidth: '45%'
        },

        rightColumn: {
            flex: 1,
            minWidth: '45%'
        },

        segmentsContainer: {
            paddingVertical: 16,
            paddingHorizontal: 20,
            borderTopWidth: 1,
            borderTopColor: '#f0f0f0'
        },

        segmentsContent: {
            flexDirection: 'column'
        },

        segmentRow: {
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            marginBottom: 10,
            paddingLeft: 10
        },
        segmentLabel: {
            minWidth: 200,
            color: '#333',
            fontWeight: '500',
            flex: 1,
            maxWidth: 250
        },
        segmentButtons: {
            flexDirection: 'row',
            gap: 8,
            marginLeft: isMobile ? 0 : 60,
            marginTop: isMobile ? 10 : 0
        },
        segmentButton: {
            borderWidth: 1,
            borderColor: '#d0d7de',
            borderRadius: 6,
            paddingVertical: 6,
            paddingHorizontal: 16,
            backgroundColor: '#fff',
            minWidth: 55,
            alignItems: 'center',
            justifyContent: 'center'
        },
        activeButton: {
            backgroundColor: '#e8f1ff',
            borderColor: '#2f81f7'
        },
        buttonText: {
            color: '#555',
            fontWeight: '500'
        },
        activeText: {
            color: '#0a3069',
            fontWeight: '600'
        },
        modalOverlay: {
            flex: 1,
            backgroundColor: 'rgba(0,0,0,0.5)',
            justifyContent: 'center',
            alignItems: 'center'
        },
        modalContainer: {
            backgroundColor: '#fff',
            width: isMobile ? '90%' : '55%',
            maxWidth: 650,
            borderRadius: 12,
            padding: 24,
            alignSelf: 'center'
        },
        input: {
            borderWidth: 1,
            borderColor: '#2f81f7',
            borderRadius: 8,
            padding: 10,
            fontSize: 16,
            minHeight: 60,
            textAlignVertical: 'top',
            marginTop: 20,
            marginBottom: 20,
            backgroundColor: '#fafafa'
        },
        modalButtonRow: {
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10
        },
        ratingRow: {
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            marginBottom: 5,
            gap: 10
        },

        ratingLabel: {
            flex: 1,
            color: '#333',
            fontWeight: '500',
            marginRight: 20
        },
        valueContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            marginLeft: 30
        },

        progressContainer: {
            width: isMobile ? 350 : 700,
            justifyContent: isMobile ? 'flex-start' : 'flex-end'
        },

        ratingValue: {
            flex: 0.5,
            textAlign: 'right',
            color: '#333',
            fontWeight: '500'
        },
        mobileRatingHeaderRow: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center'
        },

        mobileRatingValue: {
            fontWeight: 'bold',
            color: '#333'
        }
    });